import { datadogLogs } from '@datadog/browser-logs';

datadogLogs.init({
  clientToken: `${process.env.REACT_APP_DD_CLIENT_TOKEN}`,
  service: `${process.env.REACT_APP_DD_SERVICE}`,
  env: `${process.env.REACT_APP_DD_ENV}`,
  version: `${process.env.REACT_APP_DD_VERSION}`,
  site: 'datadoghq.com',
  forwardErrorsToLogs: true,
  sampleRate: 100
});
